<template>
  <div
    class="modal fade"
    id="changePasswordModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="changePasswordModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="changePasswordModalLabel">
            Ubah Password
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group row">
              <label for="oldPassword" class="col-sm-2 col-form-label"
                >Password Lama</label
              >
              <div class="col-sm-10">
                <input
                  type="password"
                  v-model="form.oldPassword"
                  class="form-control"
                  id="oldPassword"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="newPassword" class="col-sm-2 col-form-label"
                >Password Baru</label
              >
              <div class="col-sm-10">
                <input
                  type="password"
                  v-model="form.newPassword"
                  class="form-control"
                  id="newPassword"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="confirmNewPassword" class="col-sm-2 col-form-label"
                >Konfirmasi Password Baru</label
              >
              <div class="col-sm-10">
                <input
                  type="password"
                  class="form-control"
                  id="confirmNewPassword"
                  v-model="form.confirmNewPassword"
                />
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-primary" @click="changePassword">
            Simpan
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
export default {
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      },
    };
  },
  methods: {
    async changePassword() {
      const change = await axios.put("user/changePassword/seller", {
        oldPassword: this.form.oldPassword,
        newPassword: this.form.newPassword,
        confirmNewPassword: this.form.confirmNewPassword,
      });

      if (change.data.status.code == 200) {
        this.$toast.success(change.data.status.message);
        $("#changePasswordModal").modal("hide");
        setTimeout(() => {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("login");
          });
        }, 500);
      } else {
        this.$toast.error(change.data.status.message);
      }
    },
  },
};
</script>
